/* Supply6 Mellow PDP — the page's only JS. IIFE, no dependencies. */
(function () {
  'use strict';

  /* ---------- 1. THEME (runs synchronously) ---------- */
  var t = null;
  try { t = localStorage.getItem('mlw-theme'); } catch (e) {}
  document.documentElement.setAttribute('data-mlw-theme', t === 'light' ? 'light' : 'dark');

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function syncToggles(mode) {
    qsa('[data-mlw-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mlw-toggle') === mode ? 'true' : 'false');
    });
  }

  window.mlwSetTheme = function (mode) {
    mode = mode === 'light' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-mlw-theme', mode);
    try { localStorage.setItem('mlw-theme', mode); } catch (e) {}
    syncToggles(mode);
  };

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-mlw-toggle]') : null;
    if (!b) return;
    e.preventDefault();
    window.mlwSetTheme(b.getAttribute('data-mlw-toggle'));
  });

  /* ---------- intro: mobile "See more" on the ingredient grid ----------
     Ported 2026-10-18 from custom.js in the "COLLECTIONS + MELLOW" theme so
     the Mellow page does not depend on that file. Runs in the capture phase
     and stops propagation, so if that custom.js handler is ever ported into
     this theme as well, it never fires and the click cannot toggle twice. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.mlw-intro__ing-see-more') : null;
    if (!btn) return;
    var inner = btn.closest('.mlw-intro__system-inner');
    var grid = inner ? inner.querySelector('.mlw-intro__ing-grid') : null;
    if (!grid) return;
    e.stopPropagation();
    var text = btn.querySelector('.mlw-intro__ing-s-m-btn');
    grid.classList.toggle('active');
    if (text) text.textContent = grid.classList.contains('active') ? 'See less' : 'See more';
  }, true);

  /* ---------- helpers ---------- */
  function money(n) {
    return '₹ ' + Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function moneyShort(n) {
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return '₹ ' + Number(n).toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- 2. HERO ---------- */
  function hero(root) {
    if (!root || root.getAttribute('data-mlw-ready')) return;
    var dataEl = root.querySelector('[data-mlw-product]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;
    root.setAttribute('data-mlw-ready', '1');

    var suffix = root.getAttribute('data-size-suffix') || '';
    var saveLabel = root.getAttribute('data-save-label') || 'Save';
    var servingLabel = root.getAttribute('data-serving-label') || '/ serving';
    var soldLabel = root.getAttribute('data-sold-label') || 'Sold out';
    var defaultSize = (root.getAttribute('data-default-size') || '').trim();

    var sizesEl = root.querySelector('[data-mlw-sizes]');
    var priceEl = root.querySelector('[data-mlw-price]');
    var wasEl = root.querySelector('[data-mlw-was]');
    var saveEl = root.querySelector('[data-mlw-save]');
    var servingEl = root.querySelector('[data-mlw-serving]');
    var stickyPrice = root.querySelector('[data-mlw-sticky-price]');
    var stickyMrp = root.querySelector('[data-mlw-sticky-mrp]');
    var stickyWas = root.querySelector('[data-mlw-sticky-was]');
    var stickySave = root.querySelector('[data-mlw-sticky-save]');
    var stickySaveAmt = root.querySelector('[data-mlw-sticky-save-amt]');
    var qtyVal = root.querySelector('[data-mlw-qty-val]');
    var errEl = root.querySelector('[data-mlw-error]');
    var atcBtns = qsa('[data-mlw-atc]', root);

    var variants = data.variants;
    var current = pickVariant();
    var qty = 1;

    function num(v) { var n = parseFloat(v.title); return isNaN(n) ? 0 : n; }

    function pickVariant() {
      var i, v;
      if (defaultSize) {
        for (i = 0; i < variants.length; i++) {
          v = variants[i];
          if (String(v.title).trim() === defaultSize && v.available) return v;
        }
      }
      var best = null;
      for (i = 0; i < variants.length; i++) {
        v = variants[i];
        if (v.available && (!best || num(v) > num(best) || (num(v) === num(best) && v.price > best.price))) best = v;
      }
      if (best) return best;
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].title).trim() === defaultSize) return variants[i];
      }
      return variants[0];
    }

    function sizeLabel(v) {
      return (v.title + (suffix ? ' ' + suffix : '')).trim();
    }

    function renderSizes() {
      if (!sizesEl) return;
      sizesEl.textContent = '';
      variants.forEach(function (v) {
        var active = v.id === current.id;
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', active ? 'true' : 'false');
        b.setAttribute('data-variant-id', v.id);
        b.tabIndex = active ? 0 : -1;
        b.className = 'mlw-hero__size' + (active ? ' is-active' : '') + (v.available ? '' : ' is-soldout');
        var ring = document.createElement('span');
        ring.className = 'mlw-hero__radio';
        ring.setAttribute('aria-hidden', 'true');
        var lab = document.createElement('span');
        lab.className = 'mlw-hero__size-label';
        lab.textContent = sizeLabel(v);
        b.appendChild(ring);
        b.appendChild(lab);
        if (!v.available) b.setAttribute('aria-label', sizeLabel(v) + ' - ' + soldLabel);
        sizesEl.appendChild(b);
      });
    }

    function select(id, focus) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) { current = variants[i]; break; }
      }
      clearError();
      renderSizes();
      renderPrice();
      if (focus && sizesEl) {
        var a = sizesEl.querySelector('.is-active');
        if (a) a.focus();
      }
    }

    function renderPrice() {
      var price = current.price / 100;
      var was = (current.compare_at_price || 0) / 100;
      var onSale = was > price;

      if (priceEl) priceEl.textContent = money(price);
      if (wasEl) { wasEl.hidden = !onSale; wasEl.textContent = onSale ? money(was) : ''; }
      if (saveEl) { saveEl.hidden = !onSale; saveEl.textContent = onSale ? saveLabel + ' ' + moneyShort(was - price) : ''; }

      /* sticky bar */
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (stickyMrp) stickyMrp.hidden = !onSale;
      if (stickyWas) stickyWas.textContent = onSale ? money(was) : '';
      if (stickySave) stickySave.hidden = !onSale;
      if (stickySaveAmt) stickySaveAmt.textContent = onSale ? money(was - price) : '';
      var n = num(current);
      if (servingEl) {
        if (n > 0) {
          servingEl.hidden = false;
          servingEl.textContent = '₹' + Math.round(price / n).toLocaleString('en-IN') + ' ' + servingLabel;
        } else {
          servingEl.hidden = true;
        }
      }
      atcBtns.forEach(function (btn) {
        var label = btn.querySelector('[data-mlw-atc-label]');
        if (label) {
          if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', label.textContent);
          label.textContent = current.available ? btn.getAttribute('data-label') : soldLabel;
        }
        btn.disabled = !current.available;
        btn.setAttribute('aria-disabled', current.available ? 'false' : 'true');
      });
    }

    function setQty(n) {
      qty = Math.max(1, Math.min(20, n));
      if (qtyVal) qtyVal.textContent = String(qty);
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function clearError() {
      if (!errEl) return;
      errEl.textContent = '';
      errEl.hidden = true;
    }

    function addToCart() {
      if (!current.available) return;
      clearError();
      atcBtns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: qty }] })
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, json: j }; });
        })
        .then(function (res) {
          if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'Could not add to cart.');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var d = document.getElementById('mini-cart');
          if (d && 'open' in d) d.open = true;
        })
        .catch(function (err) {
          showError(err && err.message ? err.message : 'Could not add to cart.');
        })
        .then(function () {
          atcBtns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
        });
    }

    /* sizes: click + arrow keys */
    if (sizesEl) {
      sizesEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-variant-id]');
        if (b) select(parseInt(b.getAttribute('data-variant-id'), 10), true);
      });
      sizesEl.addEventListener('keydown', function (e) {
        var k = e.key, d = 0;
        if (k === 'ArrowRight' || k === 'ArrowDown') d = 1;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') d = -1;
        else return;
        e.preventDefault();
        var idx = variants.indexOf(current);
        var next = variants[(idx + d + variants.length) % variants.length];
        select(next.id, true);
      });
    }

    /* qty */
    qsa('[data-mlw-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { setQty(qty + parseInt(b.getAttribute('data-mlw-qty'), 10)); });
    });

    /* atc */
    atcBtns.forEach(function (b) { b.addEventListener('click', addToCart); });

    /* tabs */
    var tabs = qsa('[data-mlw-tab]', root);
    var panels = qsa('[data-mlw-panel]', root);
    function showTab(n, focus) {
      tabs.forEach(function (tb) {
        var on = tb.getAttribute('data-mlw-tab') === String(n);
        tb.classList.toggle('is-active', on);
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        tb.tabIndex = on ? 0 : -1;
        if (on && focus) tb.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-mlw-panel') !== String(n); });
    }
    tabs.forEach(function (tb, i) {
      tb.addEventListener('click', function () { showTab(tb.getAttribute('data-mlw-tab')); });
      tb.addEventListener('keydown', function (e) {
        var d = 0;
        if (e.key === 'ArrowRight') d = 1; else if (e.key === 'ArrowLeft') d = -1; else return;
        e.preventDefault();
        var nx = tabs[(i + d + tabs.length) % tabs.length];
        showTab(nx.getAttribute('data-mlw-tab'), true);
      });
    });

    /* gallery */
    gallery(root.querySelector('[data-mlw-gallery]'));

    /* sticky bar */
    var buyRow = root.querySelector('[data-mlw-buyrow]');
    var sticky = root.querySelector('[data-mlw-sticky]');
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-visible', !en.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(buyRow);
    }

    renderSizes();
    renderPrice();
    setQty(1);
  }

  function gallery(g) {
    if (!g) return;
    var track = g.querySelector('[data-mlw-track]');
    if (!track) return;
    var slides = qsa('[data-mlw-slide]', g);
    var thumbs = qsa('[data-mlw-thumb]', g);
    var thumbsBox = g.querySelector('[data-mlw-thumbs]');
    var prev = g.querySelector('[data-mlw-prev]');
    var next = g.querySelector('[data-mlw-next]');
    var idx = 0, raf = 0;

    function setActive(i) {
      idx = i;
      thumbs.forEach(function (tb, k) {
        var on = k === i;
        tb.classList.toggle('is-active', on);
        tb.classList.toggle('is-overflow-active', k === 4 && i > 4);
        if (on) tb.setAttribute('aria-current', 'true'); else tb.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      if (thumbsBox && thumbs[i] && thumbsBox.scrollWidth > thumbsBox.clientWidth + 2) {
        var tb = thumbs[i];
        thumbsBox.scrollTo({ left: tb.offsetLeft - (thumbsBox.clientWidth - tb.offsetWidth) / 2, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
    }

    function nearest() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s, k) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - c);
        if (d < bd) { bd = d; best = k; }
      });
      return best;
    }

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' });
      setActive(i);
    }

    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var n = nearest();
        if (n !== idx) setActive(n);
      });
    }, { passive: true });

    thumbs.forEach(function (tb) {
      tb.addEventListener('click', function () { go(parseInt(tb.getAttribute('data-mlw-thumb'), 10)); });
    });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });
    window.addEventListener('resize', function () {
      var s = slides[idx];
      if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'auto' });
    });

    setActive(0);
  }

  /* ---------- 3. init ---------- */
  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    qsa('[data-mlw-hero]', root).forEach(hero);
    if (root.matches && root.matches('[data-mlw-hero]')) hero(root);
    syncToggles(document.documentElement.getAttribute('data-mlw-theme'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
